import React, { useState } from "react";
import { SearchInput } from "@toddle-edu/ds-web";
import classes from "./SearchInputWrapper.scss";

const SearchInputWrapper = ({ searchText, updateSearchText, placeholder }) => {
  const [searchValue, setSearchValue] = useState(searchText);

  const updateSearchValue = value => {
    setSearchValue(value);
    updateSearchText(value);
  };

  return (
    <div className={classes.searchBoxContainer}>
      <SearchInput
        size="medium"
        value={searchValue}
        onChange={updateSearchValue}
        placeholder={placeholder}
        dsVersion="2.0"
        focusSearchBySlash
      />
    </div>
  );
};

SearchInputWrapper.defaultProps = {
  placeholder: "search",
  isProjectNode: false,
};

export default SearchInputWrapper;
